import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Header from './components/Header';
import BreakingNews from './components/BreakingNews';
import CategoryNav from './components/CategoryNav';
import ScrollToTop from './components/ScrollToTop';
import Footer from './components/Footer';
import NotificationPrompt from './components/NotificationPrompt';
import HomePage from './pages/HomePage';
import CategoryPage from './pages/CategoryPage';
import NewsDetailPage from './pages/NewsDetailPage';
import SearchPage from './pages/SearchPage';
import Register from './pages/Register';
import AdminLogin from './pages/AdminLogin';
import AdminUpload from './pages/AdminUpload';
import SuperadminLogin from './pages/SuperadminLogin';
import SuperadminApproval from './pages/SuperadminApproval';
import UjalaNews from './pages/UjalaNews';
import ContactPage from './pages/ContactPage';
import AboutPage from './pages/AboutPage';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import PublicUploadPage from './pages/PublicUploadPage';
import { initPushNotifications } from './utils/pushNotifications';

function App() {
  // Initialize push notifications on app mount
  useEffect(() => {
    initPushNotifications().catch(err => {
      console.error('[App] Push notifications initialization error:', err);
    });

    // DEBUG: Log when beforeinstallprompt fires
    window.addEventListener('beforeinstallprompt', (e) => {
      console.log('✅ PWA Install prompt is ready!', e);
    });
  }, []);

  return (
    <HelmetProvider>
      <Router>
        <div className="app">
          <ScrollToTop />
          <Header />
          <BreakingNews />
          <CategoryNav />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/category/ujala" element={<UjalaNews />} />
            <Route path="/category/:category" element={<CategoryPage />} />
            <Route path="/admin/login" element={<Register />} />
            <Route path="/admin/signin" element={<AdminLogin />} />
            <Route path="/admin/upload" element={<AdminUpload />} />
            <Route path="/public-upload" element={<PublicUploadPage />} />
            <Route path="/superadmin/login" element={<SuperadminLogin />} />
            <Route path="/superadmin/approval" element={<SuperadminApproval />} />
            <Route path="/news/:slug" element={<NewsDetailPage />} />
            <Route path="/search" element={<SearchPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/contact" element={<ContactPage />} />
          </Routes>
          <Footer />
        </div>
        <NotificationPrompt />
      </Router>
    </HelmetProvider>
  );
}

export default App;
